import React from 'react';
import { memoizeFunction, toCamelCasedKeys, toTitleCasedKeys } from '@agilepoint/utils-common';
import { useTranslate } from '@agilepoint/wat-react';
import { CenteredSpinner } from 'common';
import { IAnnouncementParam, useUpdateAnnouncementQuery } from 'modules/shared/queries';
import { CreateAccouncement } from '../component/parts/user-details/create-announcement';
import { useAllNotificationQuery } from '../queries';
import { useConfigScopeSelectors } from '../scopes';

export function EditAnnouncementContainer(props: {
    id: string;
    removePopup?: (id: string) => void;
}) {
    const { data, isLoading, error } = useAllNotificationQuery();
    const { mutateAsync } = useUpdateAnnouncementQuery();
    const currentUserDetails = useConfigScopeSelectors().selectCurrentUserDetails();
    const translate = useTranslate();

    const saveAnnouncementInfo = React.useCallback((formData: IAnnouncementParam) => mutateAsync({
        announcement: {
            Id: props.id,
            ...toTitleCasedKeys(formData)
        },
        createdBy: currentUserDetails.userName
    }), [currentUserDetails.userName, mutateAsync, props.id]);

    if (isLoading) {
        return <CenteredSpinner width='630px' height='680px' size='small' spinnerType='indeterminate' text={translate('modules.defaultAppSettings.notificationList.loadingNotificationText')} />;
    }

    if (data) {
        const notificationInfo = toCamelCasedKeys(data, true);
        const announcementInfo = getNotificationData(notificationInfo.getAllNotificationsResult, props.id);
        return (
            <CreateAccouncement saveAnnouncementInfo={saveAnnouncementInfo}
                popupId="edit-announcement" announcementData={announcementInfo} removePopup={props.removePopup} />
        );
    }

    return (
        <>
            <span>Error: {error}</span>
        </>
    );
}

const getNotificationData = memoizeFunction((data: any, id: string) => (data.find((i: any) => i.id === id)));
